module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    ref: "main",
    staticClass: "ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-news"
  }, [_c('div', {
    staticClass: "ushk-news__h ushk-news__h_tabs"
  }, [_c('div', {
    staticClass: "ushk-news__logo",
    on: {
      "click": function($event) {
        return _vm.onChannelChange(0)
      }
    }
  }, [_c('i')]), _vm._v(" "), _c('div', {
    staticClass: "ushk-news__h_tabs"
  }, _vm._l((_vm.channels), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ushk-news__h_tab",
      class: {
        active: _vm.channelId === item.id
      },
      on: {
        "click": function($event) {
          return _vm.onChannelChange(item.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ushk-news__handle"
  }, [_c('ushk-switch', {
    attrs: {
      "text": "通知"
    },
    model: {
      value: (_vm.isOpenNotice),
      callback: function($$v) {
        _vm.isOpenNotice = $$v
      },
      expression: "isOpenNotice"
    }
  }), _vm._v(" "), _c('ushk-switch', {
    attrs: {
      "text": "声音"
    },
    model: {
      value: (_vm.isOpenVoice),
      callback: function($$v) {
        _vm.isOpenVoice = $$v
      },
      expression: "isOpenVoice"
    }
  }), _vm._v(" "), _c('ushk-switch', {
    attrs: {
      "text": "只看重要"
    },
    on: {
      "input": _vm.onOnlyImChange
    },
    model: {
      value: (_vm.onlyImportant),
      callback: function($$v) {
        _vm.onlyImportant = $$v
      },
      expression: "onlyImportant"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-news__b"
  }, [_c('flash-list', {
    attrs: {
      "currentChannel": _vm.channelId,
      "is-open-notice": _vm.isOpenNotice,
      "is-open-voice": _vm.isOpenVoice,
      "only-important": _vm.onlyImportant
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-side"
  }, [_c('div', {
    staticClass: "ushk-side__wrap",
    style: ({
      left: _vm.sideLeft
    })
  }, [_c('ad'), _vm._v(" "), _c('contract'), _vm._v(" "), _c('Declatration')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-347d9b10","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/pages/home.vue
// module id = PZPv
// module chunks = 1